var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-block my-1",class:{ 
        'btn-primary': _vm.primary && !_vm.isOutlined, 
        'btn-secondary': _vm.secondary && !_vm.isOutlined,
        'btn-outline-primary': _vm.isOutlined && _vm.primary,
        'btn-outline-secondary': _vm.isOutlined && _vm.secondary,
    },attrs:{"disabled":_vm.disabled,"title":_vm.title},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }